import { apiClient } from "../../Service";
import { objectToUserProfile, collectionToUserProfileActivities, collectionToUserProfileMissions, } from "./Transformer";
async function getProfileInfo(userId) {
    const client = apiClient();
    const params = {
        user_id: userId,
    };
    return client
        .get("profile/info", { params })
        .then((response) => objectToUserProfile(response.data));
}
async function getProfileActivities(userId) {
    const client = apiClient();
    const params = {
        user_id: userId,
    };
    return client
        .get("profile/stats", { params })
        .then((response) => collectionToUserProfileActivities(response.data));
}
async function getProfileMissions(userId) {
    const client = apiClient();
    const params = {
        user_id: userId,
    };
    return client
        .get("profile/missions", { params })
        .then((response) => collectionToUserProfileMissions(response.data));
}
export const ProfileService = {
    getProfileInfo,
    getProfileActivities,
    getProfileMissions,
};
